import { z } from "zod";

import { MetaDataSchema } from "@/schemas/meta-data";

export const ApiKeySchema = z.object({
	id: z.number().gt(0),
	name: z.string().nullable(),
	apiKey: z.string().nullable(),
	createdAt: z.string().nullable(),
});

export const ApiKeyResponseSchema = z.object({
	data: z.array(ApiKeySchema),
	meta: MetaDataSchema,
});

export const ApiKeyDeleteResponseSchema = z.object({
	message: z.string(),
});

export const CreateApiKeySchema = z.object({
	name: z.string().min(1),
});

export type ApiKey = z.infer<typeof ApiKeySchema>;
export type ApiKeyResponse = z.infer<typeof ApiKeyResponseSchema>;
export type ApiKeyDeleteResponse = z.infer<typeof ApiKeyDeleteResponseSchema>;
export type CreateApiKey = z.infer<typeof CreateApiKeySchema>;
